import React, { Component } from 'react';
import './NotFound.css';
import { connect } from 'react-redux';

class NotFound extends Component {

    constructor(props){
        super(props);
        this.state = {value: ''};
        console.log(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        console.log(event.target.value);
    }

    handleSubmit(event) {
        alert('A name was submitted: ' + this.state.value);
        event.preventDefault();
        console.log(this.state);
    }

    render() {
        return (
            <div className="NotFound">
                <h1>Page Not Found!</h1>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        Name:
                        <input type="text" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    <input type="submit" value="Submit" />
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        count: state.count
    };
}

export default connect(mapStateToProps)(NotFound);


// WEBPACK FOOTER //
// ./src/components/pages/NotFound/NotFound.js